import React from "react";
import ProductList from "../components/ProductList";

const HomePage = () => {
  return <ProductList />;
};

export default HomePage;
